import { Filters } from "consts/paymentMethods";
import { selectPaymentMethodsData } from "features/paymentMethods/selectors";
import type { PaymentMethod } from "features/paymentMethods/types";
import { useTypedSelector } from "hooks";
import { useFeatureFiltersContext, useFiltersModel } from "ui/widgets/Filters";
import { Option } from "util/option";
import useMerchantDetailsTabContext from "../../useMerchantDetailsTabContext";
import type { MerchantPaymentMethodsRepository } from "../repository";

export default function useAddMerchantPaymentMethodModel(mode: 'single' | 'bulk' = 'single') {
    const paymentMethods = useTypedSelector(selectPaymentMethodsData(({ isAssignable }: PaymentMethod) => Number(isAssignable) === 1));

    const { filters } = useFeatureFiltersContext();
    const repository = useMerchantDetailsTabContext<MerchantPaymentMethodsRepository>();
    const assignedIds = new Set(repository.merchantsMethods.map(method => String(method.methodId)));
    const available = paymentMethods.filter(method => !assignedIds.has(String(method.coreId)));
    const getSelected = (id: string) => {
        const value = (filters.find(filter => filter.props.id === id)?.props as any)?.value;
        return [value].flat().filter(Boolean).map((option: any) => String(option.id));
    };
    const selectedTags = getSelected(Filters.tag);
    const selectedPSPs = getSelected(Filters.PSP);
    const tags = Array.from(new Set(available
        .filter(() => mode === 'single' || selectedPSPs.length === 1)
        .filter(method => !selectedPSPs.length || selectedPSPs.includes(method.PSP))
        .map(method => method.tag))).sort().map(value => Option.make(value));
    const providers = Array.from(new Set(available.map(method => method.PSP)))
        .filter(provider => !selectedTags.length || selectedTags.every(tag =>
            available.some(method => method.PSP === provider && method.tag === tag)
        )).sort().map(value => Option.make(value));

    return useFiltersModel({
        [Filters.tag]: tags,
        [Filters.PSP]: providers
    });
};
